import { getToken, removeToken } from '@/utils/auth'
import { getUrlMerchantId } from '@/utils/storage'
import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL !== undefined ? process.env.VUE_APP_API_BASE_URL : 'https://act.sweetour.com',
  timeout: 30000
})

request.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    const merchantId = getUrlMerchantId()
    if (merchantId) {
      config.headers['X-Merchant-Id'] = merchantId
    }

    return config
  },
  error => Promise.reject(error)
)

request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== undefined && res.code !== 200) {
      if (res.code === 401) {
        removeToken()
        const mid = getUrlMerchantId()
        window.location.href = mid ? `/login?merchantid=${mid}` : '/login'
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    console.error('Network Error:', error)
    return Promise.reject(error)
  }
)

export default request
